import Vue from 'vue'
class EventBus extends Vue{
    // cachedEvent=[];
    // on(eventName,callBack:Function){
    //     // debugger
    //     if(_.find(this.cachedEvent,(o)=>o==eventName)!=null){
    //         this.$off(eventName,callBack);
    //     }
    //     this.$on(eventName,callBack);
    //     this.cachedEvent.push(eventName);
    // }
    //
    // off(eventName,callback?:Function){
    //     this.$off(eventName,callback);
    //     _.remove(this.cachedEvent,(o)=>o==eventName);
    // }
}

export const eventBus = new EventBus();